// @flow
import React, { PureComponent } from 'react';

import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import Loading from 'components/fragments/Loading';

import { withHelmet } from 'infrastructure/seo/Helmet';
import { getMetaBySlug } from 'utils/seoUtils';

import { STATUS_SUCCESS } from 'constants/statusConstants';

import type { AlbumType } from 'types/Albums';
import type { Status } from 'types/Status';
import type { RencontreType } from 'types/Rencontre';

function EmptyState() {
  return (
    <div className="placeholder ">
      <p className="ft-h5">
        <i className="icon icon-camera"></i>
        <br />
        Aucun média pour cette recherche
      </p>
    </div>
  );
}

export type StateProps = {
  album: AlbumType,
  status: Status,
  rencontre: ?RencontreType
};

type Props = StateProps;

class RencontreMedias extends PureComponent<Props> {
  renderAlbum = () => {
    const {
      album: {
        content: { data }
      }
    } = this.props;

    const dataToDisplay = data.filter(blocFigure => blocFigure.tagName === 'galleryalbum');

    if (dataToDisplay.length < 1) {
      return <EmptyState />;
    }

    return dataToDisplay.map((blocFigure, i) => <ContentBloc key={'album_' + i} {...blocFigure} />);
  };

  render() {
    const { status, rencontre } = this.props;

    if (status !== STATUS_SUCCESS) {
      return <Loading />;
    }

    if (
      !rencontre ||
      !rencontre.id ||
      !rencontre.dateEffective ||
      !rencontre.localStructure ||
      !rencontre.localStructure.nom ||
      !rencontre.visiteurStructure ||
      !rencontre.visiteurStructure.nom
    ) {
      return <EmptyState />;
    }

    const {
      dateEffective,
      localStructure: { nom: teamA },
      visiteurStructure: { nom: teamB }
    } = rencontre;

    const saison = dateEffective.getFullYear();

    return (
      <section>
        <h2 className="mt-3">{`Photos ${teamA} - ${teamB} saison ${saison}`}</h2>
        <div className="page">
          {/* @ TODO: HEADER FILTER */}
          <div className="row">
            <div className="col col-lg-8on9">{this.renderAlbum()}</div>
          </div>
        </div>
      </section>
    );
  }
}

export default withHelmet(RencontreMedias)((Helmet, pageProps) => {
  const { rencontre } = pageProps;

  const teamA = rencontre.localStructure.nom;
  const teamB = rencontre.visiteurStructure.nom;

  const meta = getMetaBySlug('match/medias');

  return (
    <Helmet>
      <title>{meta.title(teamA, teamB)}</title>
      {meta.description() !== '' ? <meta name={'description'} content={meta.description()} /> : ''}
      <meta name={'keywords'} content={meta.keywords(teamA, teamB)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta.title(teamA, teamB)} />
      {meta.description() !== '' ? <meta property={'og:description'} content={meta.description()} /> : ''}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
